import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Type,
  ViewChild,
} from '@angular/core';
import { MatRadioGroup } from '@angular/material/radio';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { ɵobserve as observe } from '@ngx-formly/core';

interface RadioProps extends FormlyFieldProps {
  labelPosition?: 'before' | 'after';
  orientation?: 'horizontal' | 'vertical';
  gap?: string;
}

export interface FormlyRadioFieldConfig extends FormlyFieldConfig<RadioProps> {
  type: 'radio' | Type<RadioTypeComponent>;
}

@Component({
    selector: 'lockton-apps-radio-type',
    templateUrl: './radio-type.component.html',
    styleUrls: ['./radio-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RadioTypeComponent
  extends FieldType<FieldTypeConfig<RadioProps>>
  implements AfterViewInit, OnDestroy
{
  @ViewChild(MatRadioGroup, { static: true }) radioGroup!: MatRadioGroup;

  override defaultOptions = {
    props: {
      hideFieldUnderline: true,
      floatLabel: 'always' as const,
      tabindex: -1,
    },
  };

  private focusObserver!: ReturnType<typeof observe>;
  ngAfterViewInit() {
    this.focusObserver = observe(this.field, ['focus'], ({ currentValue }) => {
      if (
        this.props.tabindex === -1 &&
        currentValue &&
        this.radioGroup._radios.length > 0
      ) {
        // https://github.com/ngx-formly/ngx-formly/issues/2498
        setTimeout(() => {
          const radio = this.radioGroup.selected
            ? this.radioGroup.selected
            : this.radioGroup._radios.first;
          radio.focus();
        });
      }
    });
  }

  override onContainerClick() {}

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.focusObserver && this.focusObserver.unsubscribe();
  }
}
